import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { KEResource } from '../../ke';
import { KEnableCreate, KEnableDelete, KEnableRefresh, KEnableRefreshByID, KEnableUpdate } from './kenable.action';
import { KEService } from '../../ke.service';

export class KEnableStateModel {
  data: KEResource[] = [];
}

@State<KEnableStateModel>({
  name: 'KEnables',
  defaults: {
    data: []
  }
})

@Injectable()
export class KEnableState extends BaseState {
  constructor(
    protected override injector: Injector,
    private service: KEService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: KEnableStateModel) {
    return state.data;
  }

  @Action(KEnableRefresh)
  refresh({ patchState }: StateContext<KEnableStateModel>) {
    this.service.getAll().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(KEnableRefreshByID)
  refreshByID({ getState, patchState }: StateContext<KEnableStateModel>, { id }: KEnableRefreshByID) {
    this.service.getById(id).subscribe(data => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);

      if (index >= 0) {
        state.data.splice(index, 1);
      }
      patchState({
        data: [...state.data, data]
      });
    },
      error => console.error(error)
    );
  }

  @Action(KEnableCreate)
  create({ getState, patchState }: StateContext<KEnableStateModel>, { item }: KEnableCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  /** Applies a live KE refresh without discarding workflow details used by an open checklist. */
  @Action(KEnableUpdate)
  update({ getState, patchState }: StateContext<KEnableStateModel>, { id, item }: KEnableUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      // Keep the selected KE's workflow graph while a SignalR refresh supplies only changed fields.
      const current = state.data[index];
      const updated = {
        ...current,
        ...item,
        wfTable: item.wfTable ?? current.wfTable,
        wfSignatures: item.wfSignatures ?? current.wfSignatures
      };

      patchState({
        data: state.data.map(ke => ke.id === id ? updated : ke)
      });
    }
  }

  @Action(KEnableDelete)
  delete({ getState, patchState }: StateContext<KEnableStateModel>, { id }: KEnableDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }
}
